import React, { useEffect, useState } from "react";
import Header from "components/Header";
import DashboardMap from "components/MaharashtraMap";
import HorizontalBarCard from "components/NewComponents/HorizontalBarCard";
import FunnelChartCard from "components/NewComponents/FunnelChartCard";
import HorizontalInfantDeathChart from "components/NewComponents/InfantDeathsBar";
import WaterfallChart from "components/NewComponents/WaterfallChart";
import BubbleGridChart from "components/NewComponents/BubbleGridChart";
import LineBarChart from "components/NewComponents/LineBarChartCard";
import DonutChart from "components/NewComponents/DonutChartCard";
import TreemapCard from "components/NewComponents/TreemapCard"

import {
    FaUsers,        // Population
    FaMapMarkedAlt, // District
    FaCity,         // Tehsil
    FaMapSigns,     // Block
    FaHome,         // Gram Panchayat
    FaTree,         // Village
    FaLocation,       // location
    FaBaby,
    FaHospital,
    FaSyringe,
    FaHeartbeat,
    FaUserMd
} from "react-icons/fa";

const neonatalData = [
    { district: "Nanded", value: 45 },
    { district: "Sangli", value: 32 },
    { district: "Beed", value: 28 },
    { district: "Kolhapur", value: 24 },
    { district: "Satara", value: 18 },
    { district: "Solapur", value: 41 },
    { district: "Latur", value: 38 },
    { district: "Gadchiroli", value: 12 },
    { district: "Pune", value: 55 },
];
const treemapData = [
    { name: "Mumbai", value: 120 },
    { name: "Pune", value: 110 },
    { name: "Nagpur", value: 95 },
    { name: "Thane", value: 102 },
    { name: "Nashik", value: 88 },
    { name: "Aurangabad", value: 76 },
    { name: "Solapur", value: 67 },
    { name: "Kolhapur", value: 58 },
    { name: "Sangli", value: 52 },
    { name: "Satara", value: 49 },
    { name: "Beed", value: 43 },
    { name: "Parbhani", value: 39 },
    { name: "Latur", value: 47 },
    { name: "Jalgaon", value: 55 },
    { name: "Buldhana", value: 36 },
    { name: "Yavatmal", value: 32 },
    { name: "Chandrapur", value: 30 },
    { name: "Gondia", value: 28 },
    { name: "Wardha", value: 25 },
    { name: "Osmanabad", value: 22 }
];
const FUNNEL_DATA = [
    { name: "Population", value: 64300000 },
    { name: "Enrolled", value: 41713601 },
    { name: "Enrolled 30+", value: 26709193 },
];
const fullyImmunizedData = [
    { name: "Maharashtra", value: 9 },
    { name: "Other States", value: 91 }
];
const infantDeaths = [
    { district: "Pune", deaths: 120 },
    { district: "Nagpur", deaths: 105 },
    { district: "Nashik", deaths: 98 },
    { district: "Aurangabad", deaths: 86 },
    { district: "Thane", deaths: 80 },
];
const outbreakData = [
    { label: "Food borne", value: 50 },
    { label: "Vector borne", value: 23 },
    { label: "Person to person", value: 23 },
    { label: "Zoonoses", value: 3 },
    { label: "Other", value: 1 },
];
function HealthIntelligenceDashboard() {
    const [districtView, setDistrictView] = useState(null);
    const [seed, setSeed] = useState(0);
    // const [currentBirths, setCurrentBirths] = useState(DEFAULT_BIRTHS);
    const [stateGeoJSON, setStateGeoJSON] = useState(null);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // state polygon
            .then((res) => res.json())
            .then((data) => setStateGeoJSON(data))
            .catch((err) => console.error("GeoJSON load error:", err));
    }, []);

    const [districtsGeoJSON, setdistrictsGeoJSON] = useState(null);
    useEffect(() => {
        fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // <- all districts
            .then((res) => res.json())
            .then((data) => setdistrictsGeoJSON(data))
            .catch((err) => console.error("GeoJSON load error:", err));
    }, []);
    const handleMenuClick = () => {
        // alert("Sidebar opened! (You can link this to real sidebar)");
    };

    const [searchQuery, setSearchQuery] = useState("");
    const [selected, setSelected] = useState("");
    return (
        <>
            <Header
                onMenuClick={handleMenuClick}
                selected={selected}
                setSelected={setSelected}
                onSearchChange={setSearchQuery}
                dashboardName="Health Intelligence Dashboard"
            />

            <div className="container-fluid p-2">
                <div className="row g-3"> {/* g-3 = gap between cards */}

                    {/* Card 1 */}
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <BubbleGridChart
                            title="Neonatal Deaths"
                            data={neonatalData}
                            columns={5}
                            height={300}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <HorizontalBarCard
                            title="Screened & Examined"
                            categories={["Hyper Tension", "Diabetes Mellitus", "Cancer"]}
                            height={300}
                            screened={[31, 31, 45]}
                            examined={[16, 16, 17]}

                        />
                    </div>

                    {/* Card 2 */}
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <FunnelChartCard
                            title="Population Vs Enrolled Vs Enrolled 30+"
                            data={FUNNEL_DATA}
                            height={300}
                        />
                    </div>

                    {/* Card 3 */}
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <DonutChart
                            data={fullyImmunizedData}
                            title="Fully Immunized - Male vs Female"
                            height={300}
                        />
                    </div>

                    {/* Card 4 */}
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <HorizontalInfantDeathChart data={infantDeaths} />
                    </div>

                    {/* Card 5 */}
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <WaterfallChart
                            title="Outbreak Reason (%)"
                            data={outbreakData}
                        />
                    </div>

                    {/* Card 6 */}


                </div>
            </div>
        </>
    );
}
export default HealthIntelligenceDashboard;